import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalBerhasil extends React.Component {
    render() {
        const { showModalBerhasil, CancelHandler, DeleteHandler2, Model } = this.props

        return (
            <div>
                <Modal show={showModalBerhasil} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>UBAH RENCANA KEDATANGAN</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Ubah Rencana Kedatangan Berhasil <br /> <br />
                        </p>
                        
                    </Modal.Body>

                    <Modal.Footer>



                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}